import ResidenceGrid from '../components/ResidenceGrid';
import { useLanguage } from '../context/LanguageContext';

function ResidencesPage() {
  const { language } = useLanguage();

  return (
    <section className="page-shell residences-page">
      <header className="page-intro">
        <span className="eyebrow">AMR · Sveti Stefan</span>
        <h1>{language === 'ru' ? 'Апартаменты для аренды' : 'Apartments for your stay'}</h1>
        <p>
          {language === 'ru'
            ? 'Выберите подходящее пространство, посмотрите фотографии и проверьте свободные даты.'
            : 'Choose the space that suits you, explore its photographs and check availability for your dates.'}
        </p>
      </header>
      <ResidenceGrid />
    </section>
  );
}

export default ResidencesPage;
